/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { ToastContainer } from 'react-toastify';
import Pagination from '../Pagination/pagination';
import { NavLink, } from 'react-router-dom';
import Spinner from '../Spinner/spinner';
import { Button } from '@mui/material';
import UseProvider from './Hooks/useProvider';


const ServiceProvider = () => {
  const {
    deleteServiceProvider,
    setServiceProvideId,
    invitationResend,
    listServiceProvider,
    handleChange,
    statusChange,
    navigate,
    setPage,
    serviceProviderData,
    PER_PAGE,
    spinner,
    filter,
    count,
    page,
  } = UseProvider()
  return (
    <>
      <ToastContainer />
      <section>
        <div className="m-t-3 cus-padd cusheight">
          {spinner ? <Spinner /> : null}
          <header>
            <h2 className='page-tittle'>
              Provider List
            </h2>
            <hr />
          </header>
          <p className='mb-0'>Total Provider : {serviceProviderData.totalCount}</p>
          <div className='d-flex justify-content-end align-item-center' >
            <div className='me-2'>
              <input style={{ justifyContent: 'start', marginTop: '25px', paddingBottom: '5px' }} className='search me-2 form-control' type="text" name="provider" placeholder='Search by provider'
                value={filter.provider}
                onChange={(e) => handleChange(e)}
              />
            </div>
            <div className='me-2'>
              <input style={{ justifyContent: 'start', marginTop: '25px', paddingBottom: '5px' }} className='search me-2 form-control' type="text" name="email" placeholder='Search by email'
                value={filter.email}
                onChange={(e) => handleChange(e)}
              />
            </div>
            {/* <div className='me-2'>
              <label className="form-label"></label>
              <select className='form-select' name='deleted' value={filter.deleted} onChange={(e) => { handleChange(e) }}>
                <option hidden>Team</option>
                <option value={true}>Deleted</option>
                <option value={false}>Not Deleted</option>
              </select>
            </div> */}
            <div className='me-2'>
              <label className="form-label"></label>
              <select className='form-select me-2' name='status' value={filter.status} onChange={(e) => { handleChange(e) }}>
                <option hidden>Status</option>
                <option value={true}>Active</option>
                <option value={false}>In-Active</option>
              </select>
            </div>
            <div className='me-2'>
              <label className="form-label"></label>
              <select className='form-select me-2' name='isAssignLoginForProvider' value={filter.isAssignLoginForProvider} onChange={(e) => { handleChange(e) }}>
                <option hidden>Status</option>
                <option value={true}>Assign Login</option>
                <option value={false}>Un-Assign Login</option>
              </select>
            </div>
            <div class="dropdown d-flex align-items-center">
              <button className="btn btn-primary  float-end px-3 my-4 " onClick={() => listServiceProvider()}>Search</button>
              <button className="btn btn-dark   px-4 my-4 ms-2" onClick={() => window.location.reload()}>Reset</button>
              <NavLink to='addProvider'>
                <button className='btn btn-dark ms-2' >Add</button>
              </NavLink>
            </div>
          </div>

          <table className="table  shadow mt-3">
            <thead className="table-dark">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Provider</th>
                <th scope="col">Email</th>
                <th scope="col">Mobile</th>
                <th scope="col">Confirmation Status</th>
                <th scope="col">Status</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {
                serviceProviderData?.data?.length === undefined ? <div className='position-absolute top-10 end-50 mt-5 me-5'><h3>No record found</h3></div>
                  :
                  <>
                    {
                      serviceProviderData.data?.map((item, index) => {
                        return <>
                          <tr key={index}>
                            <th scope="row">{PER_PAGE * (page - 1) + index + 1}</th>
                            <td>{item.name}</td>
                            <td>{item.email}</td>
                            <td>{item.mobileNo}</td>
                            <td>{item.isAccepted === 'incomplete_profile' ? 'Profile Incomplete' : item.isAccepted?.charAt(0).toUpperCase() + item.isAccepted?.slice(1)}</td>
                            <td>
                              <div className="form-check form-switch" style={{ marginLeft: '44%' }}>
                                <input className="form-check-input" role='switch' type="checkbox" checked={item.isAssignLoginForProvider} onChange={() => statusChange(item)} />
                              </div>
                            </td>
                            <td>
                              {
                                item.isDeleted === true ? null
                                  :
                                  <>
                                    <Button variant="text" sx={{ color: 'black', fontSize: '12px' }} id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                      <i className="fa-solid fa-ellipsis-vertical cursor"></i>
                                    </Button>
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                      <a className="dropdown-item cursor" onClick={() => navigate(`assign-plan/${item._id}`)} >Assign Plan</a>
                                      <a className="dropdown-item cursor" onClick={() => navigate(`editProvider/${item._id}`)}>Edit</a>
                                      <a className="dropdown-item cursor" data-bs-toggle="modal" data-bs-target="#invitationResend" onClick={() => setServiceProvideId(item?._id)}>Re-send invitation </a>
                                      <a className="dropdown-item cursor" onClick={() => navigate(`plan-details/${item._id}`)}>View Details</a>
                                      {/* <a className="dropdown-item cursor"  onClick={() => navigate(`view/${item._id}`)}>View</a> */}
                                    </ul>
                                  </>
                              }

                            </td>
                          </tr>
                        </>
                      })
                    }
                  </>
              }
            </tbody>
          </table>
          <div className='w-100 d-flex justify-content-center mt-5 pb-3'>
            {serviceProviderData?.length === 0 ? null : count > 10 && <Pagination setpage={setPage} count={Math.ceil(count / PER_PAGE)} page={page} />
            }
          </div>

          {/* Delete Service Provider Start */}
          <div className="modal fade" id="unavailabilitydelete" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-sm">
              <div className="modal-content">
                <div className="modal-body text-center">
                  <p>Are you sure !</p>
                  <p>You want to delete your provider
                  </p>
                  <button type="button" className="btn nobtn" data-bs-dismiss="modal">No</button>
                  <button type="button" onClick={() => deleteServiceProvider()} className="btn yesbtn" data-bs-dismiss="modal">Yes</button>
                </div>

              </div>
            </div>
          </div>
          {/* Delete Service Provider End */}
          {/* Modal convert to provider */}
          <div className="modal fade" id="invitationResend" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-sm">
              <div className="modal-content">
                <div className="modal-body text-center">
                  <p>Are you sure !</p>
                  <p>You want to re-send invitation
                  </p>
                  <button type="button" className="btn nobtn" data-bs-dismiss="modal">No</button>
                  <button type="button" onClick={() => invitationResend()} className="btn yesbtn" data-bs-dismiss="modal">Yes</button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default ServiceProvider;